var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "c-outage-result__unplanned",
      class: {
        "c-outage-result__unplanned--list-view": _vm.outagePageView === "list",
      },
    },
    [
      _c("div", { staticClass: "c-outage-result__unplanned-triangle" }),
      _vm._v(" "),
      _c("div", { staticClass: "c-outage-result__wrapper" }, [
        _c("img", {
          staticClass: "c-outage-result__graphic",
          attrs: { src: _vm.getMarkerIcon(_vm.outage) },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "c-outage-result__details" },
          [
            _c("p", { staticClass: "c-outage-result__outage-number" }, [
              _vm._v(_vm._s("#" + _vm.outage.id)),
            ]),
            _vm._v(" "),
            _c("h3", { staticClass: "c-outage-result__outage-title" }, [
              _c("a", { attrs: { href: _vm.outage.link } }, [
                _vm._v(
                  "\n          " + _vm._s(_vm.outage.suburbsText) + "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "c-outage-result__outage-type" }, [
              _vm._v("Unplanned outage"),
            ]),
            _vm._v(" "),
            _vm.filterOption == "current"
              ? [
                  _c("p", { staticClass: "c-outage-result__start-time" }, [
                    _vm._v("\n          Start date/time:\n          "),
                    _c("span", { staticClass: "c-outage-result__bold" }, [
                      _vm._v(_vm._s(_vm.formatDate(_vm.outage.timeOfFault))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "c-outage-result__start-time" }, [
                    _vm._v("\n          Estimated restoration:\n          "),
                    _c("span", { staticClass: "c-outage-result__bold" }, [
                      _vm._v(_vm._s(_vm.formatDate(_vm.outage.lastUpdatedEta))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.outage.lastUpdatedCustomersAffected > 0
                    ? [
                        _c(
                          "p",
                          { staticClass: "c-outage-result__update" },
                          [
                            _vm._v(
                              "\n            We have " +
                                _vm._s(
                                  _vm.outage.lastUpdatedCustomersAffected
                                ) +
                                " affected\n            customers\n            "
                            ),
                            _vm.outage.lastUpdatedEta
                              ? [
                                  _vm._v(
                                    "\n              and expect to restore power\n              " +
                                      _vm._s(
                                        _vm.timeFromNoFuture(
                                          _vm.outage.lastUpdatedEta
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ]
                              : [
                                  _vm._v(
                                    "\n              . Estimated time of restoration to be confirmed\n            "
                                  ),
                                ],
                          ],
                          2
                        ),
                      ]
                    : [
                        _vm.outage.lastUpdatedEta
                          ? _c(
                              "p",
                              { staticClass: "c-outage-result__update" },
                              [
                                _vm._v(
                                  "\n            We expect to restore power\n            " +
                                    _vm._s(
                                      _vm.timeFromNoFuture(
                                        _vm.outage.lastUpdatedEta
                                      )
                                    ) +
                                    "\n          "
                                ),
                              ]
                            )
                          : _c(
                              "p",
                              { staticClass: "c-outage-result__update" },
                              [
                                _vm._v(
                                  "\n            Estimated time of restoration to be confirmed\n          "
                                ),
                              ]
                            ),
                      ],
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.filterOption == "recent"
              ? [
                  _c("p", { staticClass: "c-outage-result__start-time" }, [
                    _vm._v("\n          Start date/time:\n          "),
                    _c("span", { staticClass: "c-outage-result__bold" }, [
                      _vm._v(_vm._s(_vm.formatDate(_vm.outage.timeOfFault))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "c-outage-result__end-time" }, [
                    _vm._v("\n          End date/time:\n          "),
                    _c("span", { staticClass: "c-outage-result__bold" }, [
                      _vm._v(
                        _vm._s(_vm.formatDate(_vm.outage.lastUpdatedTime))
                      ),
                    ]),
                  ]),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c("p", { staticClass: "c-outage-result__last-updated" }, [
              _vm._v(
                "\n        Updated " +
                  _vm._s(_vm.timeFrom(_vm.outage.lastUpdatedTime)) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "c-outage-result__link",
                attrs: { href: _vm.outage.link },
              },
              [
                _vm._v("More details"),
                _c("span", [
                  _c("img", {
                    attrs: {
                      src: "_resources/app/client/assets/icons/outages-map/more-details-arrow.svg",
                    },
                  }),
                ]),
              ]
            ),
            _vm._v(" "),
            _vm.outagePageView == "map"
              ? _c(
                  "span",
                  {
                    staticClass: "c-outage-result__zoom",
                    on: {
                      click: function ($event) {
                        return _vm.zoomToMap(_vm.outage)
                      },
                    },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: "_resources/app/client/assets/icons/outages-map/map-icon.svg",
                      },
                    }),
                  ]
                )
              : _vm._e(),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }